/* eslint-disable react-hooks/exhaustive-deps */
// import { Treemap } from '@ant-design/plots';
import { Gauge } from "@ant-design/plots";
import { Button, Collapse, Image, ImageViewer, Swiper } from "antd-mobile";
import Certificate from "components/alert/Certificate";
import transverterFn from "i18nData";
import { truncateString } from "modules/common";
import About from "pages/commonBox/About";
import Header from "pages/commonBox/Header";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
// import Share from "components/alert/Share";
import { useHistory } from "react-router-dom";
import r, { api } from "../../modules/Request";
import "./../HomePage/HomePage.scss";
import add_icon from "./../HomePage/images/add_icon.png";
import blockchainicon from "./../HomePage/images/blockchain.png";
// import carbonjyicon from "./../HomePage/images/cabonjy.png";
import icon_right from "./../HomePage/images/icon_right.png";
// import jd1icon from "./../HomePage/images/jd1.png";
// import jd2icon from "./../HomePage/images/jd2.png";
// import jd3icon from "./../HomePage/images/jd3.png";
// import jd4icon from "./../HomePage/images/jd4.png";
// import jd5icon from "./../HomePage/images/jd5.png";
import munus_icon from "./../HomePage/images/minus_icon.png";
// import producttypeicon from "./../HomePage/images/producttype.png";
// import productxhicon from "./../HomePage/images/productxh.png";
// import productzlicon from "./../HomePage/images/productzl.png";
// import productzqicon from "./../HomePage/images/productzq.png";
import rightarrrowicon from "./../HomePage/images/rightarrow.png";
import yeziicon from "./../HomePage/images/yezi.png";

const HomePage = () => {
  const history = useHistory();
  const { id, type } = r.getQueryString();
  const language = useSelector((state) => state.language);
  const [visibleImg, setVisibleImg] = useState(false);
  const [technologyFlowImg, setTechnologyFlowImg] = useState(false);
  const imageViewerRef = useRef(0);
  const [emissionimgList, setEmissionImgList] = useState([]);
  const [emissionimgListImg, setEmissionimgListImg] = useState(false);
  const [visible, setVisible] = useState(false);
  const [dataVal, setDataVal] = useState([]);
  const [strAll, setStrAll] = useState({}); //写死的翻译数据
  const [resAll, setResAll] = useState([]); //接口返回的总数据
  const [visitH5Data, setVisitH5Data] = useState(false); //控制中英文

  // const jdimgLis = [jd1icon, jd2icon, jd3icon, jd4icon, jd5icon];
  const urlJoint = `id=${id + "1"}&type=${type}`;
  const urlJointAero = `id=${id + "0"}&type=${type}`;

  const config = {
    percent: parseFloat(resAll?.carbonReductionDetailVO?.ratio || 0) / 100,
    radius: 0.48,
    range: {
      color: ["#03BF8A", "#FFF"],
      width: 7,
    },
    startAngle: Math.PI - 0.5,
    endAngle: 2.14 * Math.PI,
    indicator: null,
    statistic: {
      title: {
        offsetY: -45,
        style: {
          fontSize: ".53rem",
          color: "#03BF8A",
          fontWeight: "600",
        },
        formatter: () => resAll?.carbonReductionDetailVO?.ratio || 0,
      },
      content: {
        style: {
          lineHeight: ".4rem",
          fontSize: ".27rem",
          color: "#333333",
          marginTop: "-.4rem",
        },
        formatter: () => {
          return `<div>
            ${strAll?.ReductionRatio}
            <p>${visitH5Data ? "" : "(%)"}</p>
          </div>`;
        },
      },
    },
    gaugeStyle: {
      lineCap: "round",
    },
  };

  const getFillReviewFn = async () => {
    try {
      let res = await r.get(api.CARBON_FOOTQRCODE_REDUCTION + id);
      if (res.status.code === "00000") {
        let resData = res.data;
        setDataVal(resData);
        /*  setDataVal(res.data);
         let stepListVal = res.data?.stepList.sort((a, b) => {
           return b.emissionValue - a.emissionValue;
         }); */

        // setStepList(stepListVal);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getFillReviewFn();
  }, []);
  useEffect(() => {
    setEmissionImgList(resAll?.certificateImg);
  }, [resAll]);
  useEffect(() => {
    console.log(language);
    if (language) {
      setResAll(dataVal["zhProductDetail"]);
    } else {
      setResAll(dataVal["enProductDetail"]);
    }
    setStrAll(transverterFn(language));
  }, [language, dataVal]);
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [resAll]);
  useEffect(() => {
    document.title =
      resAll?.productName + (language ? "碳减排" : " Carbon reduction");
  }, [language, resAll]);
  return (
    <div className="detail_box emission_box">
      <ImageViewer
        image={resAll?.carbonDistributtionImg}
        visible={visibleImg}
        getContainer={() => document.body}
        onClose={() => {
          setVisibleImg(false);
        }}
      />
      <ImageViewer
        image={resAll?.technologyFlowImg}
        visible={technologyFlowImg}
        getContainer={() => document.body}
        onClose={() => {
          setTechnologyFlowImg(false);
        }}
      />
      <ImageViewer.Multi
        ref={imageViewerRef}
        images={emissionimgList}
        visible={emissionimgListImg}
        defaultIndex={0}
        getContainer={() => document.body}
        onClose={() => {
          setEmissionimgListImg(false);
        }}
      />
      {/* <Share /> */}
      <Certificate visible={visible} setVisible={setVisible} list={dataVal} />
      <div className="app-content app-content-allbox">
        <div
          className="app-content-box white_box border_radius_hide"
          style={{ padding: ".1rem .32rem" }}
        >
          <Header
            resAll={resAll}
            visitH5Data={visitH5Data}
            setVisitH5Data={setVisitH5Data}
          />
        </div>

        <div className="content">
          <div className="detail_box_title" style={{ marginTop: ".64rem" }}>
            {resAll?.productName || "-"}
            {/* 产品碳减排分析 */}
          </div>
          {/* <div className="detail_box_tip">
            {strAll?.entName} {resAll?.entName || "-"}
          </div> */}
          <div className="card_bor card_bor_green">
            <div className="card_green_top">
              <div className="product-carbon-box">
                <div className="carbon-box-left">
                  {/* <p>生命周期：{resAll?.bound}</p> */}
                  {/* <p>{resAll?.carbonReductionDetailVO?.featureUnitImprove}</p> */}
                  <p>{resAll?.carbonReductionDetailVO?.featureUnit}</p>
                </div>
              </div>
              <div className="product-carbonvalue-box block_max">
                <p className="value">
                  {resAll?.carbonReductionDetailVO?.reductionCarbon}
                </p>
                <p className="unit">
                  {resAll?.carbonReductionDetailVO?.carbonReductionUnit}
                </p>
                <div className="gauge_box">
                  <Gauge {...config} />
                </div>
              </div>
            </div>
            <div className="product-carbonnumber-box-green">
              <div className="h32_box"></div>
              <div className="box-content">
                <p>
                  {strAll.BasicProduct}{" "}
                  {resAll?.carbonReductionDetailVO?.productNameBase}
                </p>
                <p>{resAll?.carbonReductionDetailVO?.featureUnitBase}</p>
                <p>
                  {resAll?.carbonReductionDetailVO?.carbonBase}
                  <span>{resAll?.carbonReductionDetailVO?.unitBase}</span>
                </p>
                <img
                  onClick={() => {
                    history.push("/home?" + urlJointAero);
                  }}
                  className="icon_right"
                  alt=""
                  src={icon_right}
                />
              </div>
              <div className="box-content box-content-green">
                <p>
                  {strAll.ImprovedProduct}{" "}
                  {resAll?.carbonReductionDetailVO?.productNameImprove}
                </p>
                <p>{resAll?.carbonReductionDetailVO?.featureUnitImprove}</p>
                <p>
                  {resAll?.carbonReductionDetailVO?.carbonImprove}
                  <span>{resAll?.carbonReductionDetailVO?.unitImprove}</span>
                </p>
                <img
                  onClick={() => {
                    history.push("/home?" + urlJoint);
                  }}
                  className="icon_right"
                  alt=""
                  src={icon_right}
                />
              </div>
            </div>
          </div>
          <Collapse
            defaultActiveKey={["1", "2", "3", "4", "5", "6", "7"]}
            arrow={(active) =>
              active ? (
                <img className="icon_size" alt="" src={munus_icon} />
              ) : (
                <img className="icon_size" alt="" src={add_icon} />
              )
            }
          >
            <Collapse.Panel key="1" title={strAll?.OverviewReduction}>
              <div className="step_reduction_box">
                <div className="step_reduction_header">
                  <div className="basics_title">{strAll?.BasicProduct}</div>
                  <div className="improve_title">{strAll?.ImprovedProduct}</div>
                  <div className="reduction_title">{strAll?.Reduction}</div>
                </div>
                <div style={{ marginTop: ".08rem" }}>
                  {resAll?.stepReductionVOList?.map((item, idx) => {
                    return (
                      <>
                        <div className="step_reduction_body step_reduction_title">
                          <div
                            style={{ paddingTop: idx === 0 ? ".43rem" : "0" }}
                            className="basics_title"
                          >
                            <div className="ml-21r">{item.name}</div>
                          </div>
                          <div
                            style={{ paddingTop: idx === 0 ? ".43rem" : "0" }}
                            className="improve_title"
                          >
                            <div className="ml-21r">{item.nameImprove}</div>
                          </div>
                          <div
                            style={{ paddingTop: idx === 0 ? ".43rem" : "0" }}
                            className="reduction_title"
                          >
                            {item.carbonReductionKgImprove
                              ? item.carbonReductionKgImprove
                              : "--"}
                          </div>
                        </div>
                        <div className="step_reduction_body step_reduction_val">
                          <div className="basics_title">
                            <div className="ml-21r">{item.carbonKgBase}</div>
                          </div>
                          <div className="improve_title">
                            <div className="ml-21r">{item.carbonKgImprove}</div>
                          </div>
                          <div className="reduction_title"></div>
                        </div>
                      </>
                    );
                  })}
                </div>
                <div className="step_reduction_tip">
                  {strAll?.functionalUnit}
                  {resAll?.featureUnit}/{resAll?.carbonUnit}
                </div>
                <Button
                  onClick={() => {
                    history.push(
                      "/emissionDetail" +
                        window.location.search +
                        "&source=home&visitH5Data=" +
                        visitH5Data
                    );
                  }}
                  className="mt-53r  detail_btnstyle"
                  block
                  color="success"
                >
                  {strAll?.CompareDetails}
                </Button>
              </div>
            </Collapse.Panel>
            <Collapse.Panel
              key="2"
              title={strAll?.CarbonReductionScenarioAnalysis}
            >
              <div className="center_box">
                <div className="scenario_analysis_box">
                  <img className="yezi_icon" src={yeziicon} alt="" />
                  <div className="scenario_analysis">
                    {resAll?.sceneAnalysis}
                  </div>
                </div>
                <div className="white-item product-Blockchain-box">
                  <p className="f48r bold">
                    <img src={blockchainicon} alt=""></img>
                    {strAll?.certificateAddress}
                    {/* <span className='detail_certificate_box' onClick={() => { setVisible(true) }}>查看证书 <RightOutlined style={{ fontWeight: 600 }} /></span> */}
                  </p>
                  <div className="hash-box">
                    <div className="detail_cz_box">
                      <p className="">Hash: </p>
                      <p className="detail_certificate_address">
                        {resAll?.certificateContent &&
                          truncateString(resAll?.certificateContent)}
                      </p>
                    </div>
                    <div
                      className={
                        resAll?.certificateAddress
                          ? "jump-box"
                          : "jump-box btn_disabled"
                      }
                      onClick={() => {
                        resAll?.certificateAddress &&
                          window.open(resAll?.certificateAddress);
                      }}
                    >
                      <img src={rightarrrowicon} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </Collapse.Panel>
            {resAll?.certificateImg?.length > 0 && (
              <Collapse.Panel
                key="3"
                title={strAll?.CarbonReductionCertificationEvaluationStart}
              >
                <Swiper
                  onIndexChange={(i) => {
                    imageViewerRef.current.swipeTo(i);
                    console.log(i, "onIndexChange1");
                  }}
                >
                  {emissionimgList?.map((item, index) => {
                    return (
                      <Swiper.Item key={index}>
                        <div className="swiper_box">
                          <Image
                            onClick={() => {
                              setEmissionimgListImg(true);
                            }}
                            height="7.13rem"
                            fit="contain"
                            src={item}
                          />
                        </div>
                      </Swiper.Item>
                    );
                  })}
                </Swiper>
              </Collapse.Panel>
            )}
            {/* <Collapse.Panel key="4" title={strAll?.ImprovedProducts || "-"}>
              <div
                className="white-item"
                style={{ padding: ".11rem .11rem .53rem .11rem" }}
              >
                <div className="swiper_bor emission_swiper">
                  <Swiper>
                    {resAll?.boxPicList?.map((item, index) => {
                      return (
                        <Swiper.Item key={index}>
                          <div className="swiper_box">
                            <Image height="6.37rem" fit="contain" src={item} />
                          </div>
                        </Swiper.Item>
                      );
                    })}
                  </Swiper>
                </div>
                <div className="new_list_box">
                  <div
                    className="detail_box_title"
                    style={{ marginTop: ".53rem", fontSize: ".64rem" }}
                  >
                    {resAll?.productName || "-"}
                  </div>
                  <div
                    className="product-info-box-item"
                    style={{ marginTop: ".42rem" }}
                  >
                    <img src={producttypeicon} alt="" />
                    <div className="item-right">
                      <p>{strAll?.productType || "-"}</p>
                      <p>{resAll?.productType || "-"}</p>
                    </div>
                  </div>
                  <div className="product-info-box-item">
                    <img src={productxhicon} alt="" />
                    <div className="item-right">
                      <p>{strAll?.productModel || "-"}</p>
                      <p>{resAll?.productModel || "-"}</p>
                    </div>
                  </div>
                  <div className="product-info-box-item">
                    <img src={productzlicon} alt="" />
                    <div className="item-right">
                      <p>{strAll?.productWeight || "-"}</p>
                      <p>
                        {resAll?.productionWeight +
                          "  " +
                          resAll?.productionWeightUnit || "-"}
                      </p>
                    </div>
                  </div>
                  <div className="product-info-box-item">
                    <img src={productzqicon} alt="" />
                    <div className="item-right">
                      <p>{strAll?.productPeriod || "-"}</p>
                      <p>
                        {resAll?.fillTime?.[0] + " - " + resAll?.fillTime?.[1]}
                      </p>
                    </div>
                  </div>
                  <div className="product-info-box-tip">
                    <p>{strAll?.productionExplain}</p>
                    <p>{resAll?.productionExplain || ""}</p>
                  </div>
                </div>
              </div>
            </Collapse.Panel>
            {resAll?.technologyFlowImg && (
              <Collapse.Panel key="5" title={strAll?.ImprovedProductProcess}>
                <div className="white-item product-technology-box ">
                  <img
                    onClick={() => {
                      setTechnologyFlowImg(true);
                    }}
                    src={resAll?.technologyFlowImg}
                    alt=""
                  />
                </div>
              </Collapse.Panel>
            )}

            <Collapse.Panel key="6" title={strAll?.FootprintofimprovedProducts}>
              <div className="white-item" style={{ padding: "0.11rem" }}>
                <div className="card_gray_top">
                  <div className="product-carbon-box">
                    <div className="carbon-box-left">
                      <p>
                        {strAll?.LifeCycle}：{resAll?.bound}
                      </p>
                      <p>{resAll?.carbonReductionDetailVO?.featureUnit}</p>
                    </div>
                    <div>
                      <img src={carbonjyicon} alt="" />
                    </div>
                  </div>
                  <div className="product-carbonvalue-box">
                    <p className="value">{resAll?.carbon}</p>
                    <span>{resAll?.carbonUnit}</span>
                  </div>
                </div>
                <div className="product-carbonnumber-box">
                  <div className="box-content">
                    <p>{strAll?.ProductionQuantity}</p>
                    <p>
                      {resAll?.productionNum}
                      <span>{resAll?.productionUnit}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="white-item product-bottom-box"
                style={{ padding: ".13rem 0.45rem" }}
              >
                {resAll?.stepList?.map((item, idx) => {
                  return (
                    <div key={item.stepKey} className="product-bottom-box-item">
                      <div className="item-left">
                        <img src={jdimgLis?.[idx]} alt="" />
                        <p className="txt-ellipsis">{item?.name || "-"}</p>
                      </div>
                      <div className="item-right">
                        <p>
                          {item.emissionValueStr || "-"}{" "}
                          <span>{item.carbonUnit || "kg CO₂e"}</span>
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Collapse.Panel>
            {resAll?.carbonDistributtionImg && (
              <Collapse.Panel key="7" title={strAll?.FootprintProducts}>
                <div className="white-item product-technology-box ">
                  <img
                    onClick={() => {
                      setVisibleImg(true);
                    }}
                    src={resAll?.carbonDistributtionImg}
                    alt=""
                  />
                </div>
              </Collapse.Panel>
            )} */}
          </Collapse>
          {/* <Button
            onClick={() => {
              history.push("/home?" + urlJoint);
            }}
            className="mt-18 detail_btnstyle"
            block
            color="success"
          >
            {strAll?.DetailsCarbonFootprint}
          </Button> */}
        </div>
        <About resAll={resAll} />
      </div>
    </div>
  );
};

export default HomePage;
